import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import CharterMarketplace from "@/pages/CharterMarketplace";
import Fleet from "@/pages/Fleet";
import AircraftDetail from "@/pages/AircraftDetail";
import CharterInquiry from "@/pages/CharterInquiry";
import Login from "@/pages/Login";
import Register from "@/pages/Register";

import PortalOverview from "@/pages/portal/PortalOverview";
import PortalTrips from "@/pages/portal/PortalTrips";
import NewTrip from "@/pages/portal/NewTrip";
import PortalTripDetail from "@/pages/portal/PortalTripDetail";
import PortalConcierge from "@/pages/portal/PortalConcierge";
import PortalProfile from "@/pages/portal/PortalProfile";

import OpsDashboard from "@/pages/ops/OpsDashboard";
import OpsTrips from "@/pages/ops/OpsTrips";
import OpsTripDetail from "@/pages/ops/OpsTripDetail";
import OpsClients from "@/pages/ops/OpsClients";
import OpsConcierge from "@/pages/ops/OpsConcierge";
import OpsSuppliers from "@/pages/ops/OpsSuppliers";
import OpsFleet from "@/pages/ops/OpsFleet";
import OpsInquiries from "@/pages/ops/OpsInquiries";

function DashboardRedirect() {
  const { user, checking } = useAuth();
  if (checking) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "client" ? "/portal" : "/ops"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" richColors position="top-right" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/charter" element={<CharterMarketplace />} />
            <Route path="/fleet" element={<Fleet />} />
            <Route path="/aircraft/:id" element={<AircraftDetail />} />
            <Route path="/charter/inquiry" element={<CharterInquiry />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/dashboard" element={<DashboardRedirect />} />

            {/* Client Portal */}
            <Route path="/portal" element={<ProtectedRoute roles={["client"]}><PortalOverview /></ProtectedRoute>} />
            <Route path="/portal/trips" element={<ProtectedRoute roles={["client"]}><PortalTrips /></ProtectedRoute>} />
            <Route path="/portal/trips/new" element={<ProtectedRoute roles={["client"]}><NewTrip /></ProtectedRoute>} />
            <Route path="/portal/trips/:id" element={<ProtectedRoute roles={["client"]}><PortalTripDetail /></ProtectedRoute>} />
            <Route path="/portal/concierge" element={<ProtectedRoute roles={["client"]}><PortalConcierge /></ProtectedRoute>} />
            <Route path="/portal/profile" element={<ProtectedRoute roles={["client"]}><PortalProfile /></ProtectedRoute>} />

            {/* Ops / Admin */}
            <Route path="/ops" element={<ProtectedRoute roles={["admin", "ops"]}><OpsDashboard /></ProtectedRoute>} />
            <Route path="/ops/trips" element={<ProtectedRoute roles={["admin", "ops"]}><OpsTrips /></ProtectedRoute>} />
            <Route path="/ops/trips/:id" element={<ProtectedRoute roles={["admin", "ops"]}><OpsTripDetail /></ProtectedRoute>} />
            <Route path="/ops/clients" element={<ProtectedRoute roles={["admin", "ops"]}><OpsClients /></ProtectedRoute>} />
            <Route path="/ops/concierge" element={<ProtectedRoute roles={["admin", "ops"]}><OpsConcierge /></ProtectedRoute>} />
            <Route path="/ops/suppliers" element={<ProtectedRoute roles={["admin", "ops"]}><OpsSuppliers /></ProtectedRoute>} />
            <Route path="/ops/fleet" element={<ProtectedRoute roles={["admin", "ops"]}><OpsFleet /></ProtectedRoute>} />
            <Route path="/ops/inquiries" element={<ProtectedRoute roles={["admin", "ops"]}><OpsInquiries /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
